import React, { useEffect, useState } from "react";
import { Palette } from "@phosphor-icons/react";

const THEMES = [
  { id: "gray",    label: "Cool Gray",        description: "Default · architectural" },
  { id: "creme",   label: "Executive Crème", description: "Heritage · warm boardroom" },
  { id: "midnight",label: "Midnight Slate",   description: "Dark · v0.1 ops room" },
];

const STORAGE_KEY = "procureo-theme";

export function applyTheme(theme) {
  const html = document.documentElement;
  if (theme === "gray") {
    html.removeAttribute("data-theme");
  } else {
    html.setAttribute("data-theme", theme);
  }
}

export default function ThemeSwitcher() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || "gray"; } catch { return "gray"; }
  });

  useEffect(() => {
    applyTheme(active);
    try { localStorage.setItem(STORAGE_KEY, active); } catch { /* ignore */ }
  }, [active]);

  const activeLabel = THEMES.find((t) => t.id === active)?.label || "Cool Gray";

  return (
    <div className="relative" data-testid="theme-switcher">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="theme-switcher-toggle"
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm
                   border border-slate-300 bg-white hover:bg-slate-100
                   font-mono text-[10px] tracking-mono-label text-slate-800 font-bold transition-colors"
        title="Switch boardroom theme"
      >
        <Palette weight="duotone" size={14} className="text-slate-700" />
        <span className="hidden sm:inline">Theme · {activeLabel}</span>
        <span className="sm:hidden">Theme</span>
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            data-testid="theme-switcher-menu"
            className="absolute right-0 top-full mt-1 z-50 w-64 rounded-sm border border-slate-300
                       bg-white shadow-md overflow-hidden"
          >
            {THEMES.map((t) => (
              <button
                key={t.id}
                data-testid={`theme-option-${t.id}`}
                onClick={() => { setActive(t.id); setOpen(false); }}
                className={`w-full text-left px-3 py-2.5 flex items-center justify-between gap-3 transition-colors
                            ${active === t.id ? "bg-emerald-50" : "hover:bg-slate-100"}`}
              >
                <div>
                  <div className="text-[12.5px] font-display font-bold text-slate-950 tracking-tight">{t.label}</div>
                  <div className="text-[10.5px] font-mono text-slate-700 font-medium">{t.description}</div>
                </div>
                {active === t.id && (
                  <span className="font-mono text-[9px] text-emerald-900 font-bold tracking-mono-label">ACTIVE</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
